import { rpc, StrKey } from "@stellar/stellar-sdk";
import { Buffer } from "buffer";

import { KeybanClientBase, KeybanClientConfig, MetadataConfig } from "~/client";
import { StellarAccount } from "~/stellar/account";
import { StellarSigner } from "~/stellar/signer";

export class StellarClient extends KeybanClientBase {
  #rpcProvider: Promise<rpc.Server>;

  constructor(
    config: KeybanClientConfig,
    metadataConfig?: Promise<MetadataConfig>,
  ) {
    super(config, metadataConfig);

    this.#rpcProvider = this.metadataConfig.then(
      (config) => new rpc.Server(config.network.rpcUrl),
    );
  }

  async initialize(): Promise<StellarAccount> {
    let clientShare = await this.clientShareProvider.get("eddsa");
    if (!clientShare) {
      clientShare = await this.rpcClient.call("eddsa", "dkg");
      await this.clientShareProvider.set("eddsa", clientShare);
    }

    const [provider, publicKey] = await Promise.all([
      this.#rpcProvider,
      this.rpcClient.call("eddsa", "publicKey", clientShare),
    ]);

    const signer = new StellarSigner(this.rpcClient, clientShare, publicKey);

    const stellarPubKey = StrKey.encodeEd25519PublicKey(
      Buffer.from(publicKey, "hex"),
    );

    return new StellarAccount(this.rpcClient, provider, signer, stellarPubKey);
  }
}
